export const getExpirationDate = (): string => {
  let date = new Date();
  date.setDate(date.getDate() + 1);
  return date.toISOString();
};

export const validExpiration = (expiration: string | null | undefined): boolean => {
  const currentDate = new Date();
  return expiration !== null && expiration !== undefined && currentDate < new Date(expiration);
};
